if (!customElements.get('main-megamenu')) {
  class MainMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        listButton: '[megamenu-hover-item]',
        listContainer: '[megamenu-hover-object]'
      };
      this.init();
    }

    init() {
      this.listButtons = this.querySelectorAll(this.selectors.listButton);
      this.listContainers = this.querySelectorAll(this.selectors.listContainer);

      // Set initial active button and container
      this.activeButton = this.querySelector(`${this.selectors.listButton}.active`) || this.listButtons[0];
      this.activeContainer = this.querySelector(`${this.selectors.listContainer}.active`) || this.getContainerByButton(this.activeButton);

      this.setActive(this.activeButton);

      this.listButtons.forEach(button => {
        button.addEventListener('mouseenter', () => this.handleMouseEnter(button));
      });
    }

    getContainerByButton(button) {
      const datasetId = button.dataset.id;
      return this.querySelector(`${this.selectors.listContainer}[data-id="${datasetId}"]`);
    }

    handleMouseEnter(button) {
      if (this.activeButton === button) return;

      this.clearActive(this.activeButton);
      this.clearActive(this.activeContainer);

      this.setActive(button);
    }

    clearActive(element) {
      if (element) element.classList.remove('active');
    }

    setActive(button) {
      const container = this.getContainerByButton(button);

      if (button) button.classList.add('active');
      if (container) container.classList.add('active');

      this.activeButton = button;
      this.activeContainer = container;
    }
  }

  customElements.define('main-megamenu', MainMegaMenu);
}
